import React, { createRef } from 'react';
import classNames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/customSelectStyle';
import withHover from 'components/withHoverHOC/withHover';

// @ts-ignore
const useStyle = makeStyles(styles);

interface ISelectItem {
	value: string;
	label: string;
	itemProps: any;
}

interface ISelectProps {
	formControlProps: object;
	inputLabelProps: object;
	selectProps: {
		variant: string;
		disableUnderline?: boolean;
	};
	inputLabel: string;
	items: ISelectItem[];
	value: React.ReactElement | string | number;
	onChange: () => void;
	hover: boolean;
	multiple?: boolean;
	disabled?: boolean;
	className?: string;
	disableUnderline?: boolean;
	menuClasses: string;
}

const CustomSelect = ({
	formControlProps,
	inputLabelProps,
	items,
	value,
	onChange,
	inputLabel,
	multiple,
	hover,
	disabled,
	className,
	disableUnderline,
	selectProps,
	menuClasses,
}: ISelectProps) => {
	const selectRef = createRef();
	const classes = useStyle();

	if (selectProps?.variant !== 'outlined') {
		selectProps = { ...selectProps, disableUnderline };
	}

	const formControlUnderline = classNames({
		[classes.selectFormControlUnderline]: true,
		// @ts-ignore
		[classes.selectFormControlNotEmptyUnderline]: !disabled && value && value.length !== 0,
		[classes.selectFormDisabledUnderline]: disabled,
	});

	const formControlClasses = classNames({
		[formControlUnderline]: !disableUnderline,
		[classes.selectFormControl]: true,
		[!!className ? className : '']: !!className,
	});

	const inputLabelClasses = classNames({
		[classes.selectLabel]: true,
		[classes.selectLabelHover]: hover && !disabled,
		[classes.selectLabelDisabled]: disabled,
	});

	const menuClass = classNames({
		[classes.selectMenu]: true,
		[menuClasses]: true,
	});

	return (
		<FormControl className={formControlClasses} {...formControlProps}>
			{inputLabel && (
				<InputLabel
					className={inputLabelClasses}
					disabled={disabled}
					classes={{
						shrink: classes.shrink,
					}}
					{...inputLabelProps}
				>
					{inputLabel}
				</InputLabel>
			)}
			<Select
				// @ts-ignore
				MenuProps={{
					className: menuClass,
					MenuListProps: {
						ref: selectRef,
					},
				}}
				classes={{
					select: classes.select,
					selectMenu: classes.selectMenuLabel,
					icon: classes.icon,
				}}
				value={value}
				onChange={onChange}
				multiple={multiple}
				IconComponent={ArrowDown}
				disabled={disabled}
				{...selectProps}
			>
				{items.map(({ value, label, itemProps }) => (
					<MenuItem
						key={value}
						value={value}
						classes={{
							root: classes.selectMenuItem,
							selected: multiple
								? classes.selectMenuItemSelectedMultiple
								: classes.selectMenuItemSelected,
						}}
						{...itemProps}
					>
						{label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default withHover(CustomSelect);
